"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledProgressBar = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _text = require("../../../styles/2_commonComponentStyles/text");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
var StyledProgressBar = _styledComponents.default.div.withConfig({
  displayName: "ProgressBarstyles__StyledProgressBar",
  componentId: "sc-1a3xmqu-0"
})(["background-color:", ";height:", ";width:100%;z-index:", ";.c-progress-bar-percent-complete{background-color:", ";height:100%;text-align:right;}.c-progress-bar-percent-label{color:", ";font-size:.8rem;font-weight:", ";letter-spacing:.07rem;line-height:1.15rem;padding-right:", ";}"], function (props) {
  return props.theme.c_background_progressBar;
}, function (props) {
  return props.theme.progressBarHeight;
}, function (props) {
  return props.theme.menu;
}, function (props) {
  return (0, _text.getForegroundColor)(props, 'primary');
}, function (props) {
  return (0, _text.getForegroundColor)(props, 'overDark');
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledProgressBar = StyledProgressBar;